import { selector } from 'recoil'
import parametersAtom from './parameters.atom'
import objectUtils from '../../utils/object.utils.ts'

const getParametersMap = selector({
  key: 'getParametersMap',
  get: ({ get }) => {
    const { items } = get(parametersAtom)

    return objectUtils.arrToMap(items, 'id')
  },
})

const getParametersByGroupIdMap = selector({
  key: 'getParametersByGroupIdMap',
  get: ({ get }) => {
    const { items } = get(parametersAtom)

    return objectUtils.arrToKeyArray(items, 'groupId')
  },
})

const getSourceIdToParameterMap = selector({
  key: 'getSourceIdToParameterMap',
  get: ({ get }) => {
    const { items } = get(parametersAtom)

    return objectUtils.arrToMap(items, 'sourceId')
  },
})

const getUnitsMap = selector({
  key: 'getUnitsMap',
  get: ({ get }) => {
    const { units } = get(parametersAtom)

    return objectUtils.arrToMap(units, 'id')
  },
})

const getUnitsPrefixesMap = selector({
  key: 'getUnitsPrefixesMap',
  get: ({ get }) => {
    const { unitPrefixes } = get(parametersAtom)

    return objectUtils.arrToMap(unitPrefixes, 'id')
  },
})

const getSourceIdToIdMap = selector({
  key: 'sourceIdToIdMap',
  get: ({ get }) => {
    const { items } = get(parametersAtom)

    return items.reduce((acc, val) => ({ ...acc, [val.sourceId]: val.id }), {})
  },
})

const parametersSelectors = {
  getParametersMap,
  getUnitsMap,
  getUnitsPrefixesMap,
  getSourceIdToIdMap,
  getSourceIdToParameterMap,
  getParametersByGroupIdMap,
}

export default parametersSelectors
